import { useEditor, EditorContent } from '@tiptap/react';
import StarterKit from '@tiptap/starter-kit';
import Link from '@tiptap/extension-link';

interface RichTextDisplayProps {
  content: string;
  emptyText?: string;
}

export default function RichTextDisplay({
  content,
  emptyText = '未填寫'
}: RichTextDisplayProps) {
  const editor = useEditor({
    extensions: [
      StarterKit.configure({
        link: false,  // Disable built-in Link from StarterKit
      }),
      Link,
    ],
    content: content,
    editable: false,
  });

  // Check if content is empty (TipTap returns <p></p> for empty content)
  const isEmpty = !content || content === '<p></p>' || content === '<p><br></p>';

  if (isEmpty) {
    return <span style={{ color: '#999' }}>{emptyText}</span>;
  }

  return (
    <div className="rich-text-display">
      <EditorContent editor={editor} />
    </div>
  );
}
